/**
 * @generated SignedSource<<aa9d592e19fc1f4a7bf7ab6fda955392>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type contextMynewsFeedViewQuery$variables = {
  applicationId: string;
  authorIds: ReadonlyArray<string | null | undefined>;
  first: number;
  hasAuthors: boolean;
  hasSections: boolean;
  hasTopics: boolean;
  sectionIds: ReadonlyArray<string | null | undefined>;
  topicIds: ReadonlyArray<string | null | undefined>;
};
export type contextMynewsFeedViewQuery$data = {
  readonly authors?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Author";
        readonly entityId: string;
        readonly entityUuid: string;
        readonly name: string;
      };
    }>;
  };
  readonly sections?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Section";
        readonly entityId: string;
        readonly entityUuid: string;
        readonly name: string;
      };
    }>;
  };
  readonly topics?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Topic";
        readonly entityId: string;
        readonly entityUuid: string;
        readonly name: string;
      };
    }>;
  };
};
export type contextMynewsFeedViewQuery = {
  response: contextMynewsFeedViewQuery$data;
  variables: contextMynewsFeedViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authorIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasAuthors"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSections"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTopics"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionIds"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicIds"
},
v8 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v9 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "authorIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "kind": "Variable",
    "name": "applicationId",
    "variableName": "applicationId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "topicIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v8/*: any*/)
],
v16 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "sectionIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v8/*: any*/)
],
v17 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "contextMynewsFeedViewQuery",
    "selections": [
      {
        "condition": "hasAuthors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "AuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasTopics",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "TopicConnection",
            "kind": "LinkedField",
            "name": "topics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TopicEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasSections",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "SectionConnection",
            "kind": "LinkedField",
            "name": "sections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "contextMynewsFeedViewQuery",
    "selections": [
      {
        "condition": "hasAuthors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "AuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasTopics",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "TopicConnection",
            "kind": "LinkedField",
            "name": "topics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TopicEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasSections",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "SectionConnection",
            "kind": "LinkedField",
            "name": "sections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "94cc04da9bf93020b818dbc367acf65f",
    "id": null,
    "metadata": {},
    "name": "contextMynewsFeedViewQuery",
    "operationKind": "query",
    "text": "query contextMynewsFeedViewQuery(\n  $authorIds: [String]!\n  $topicIds: [String]!\n  $sectionIds: [String]!\n  $hasAuthors: Boolean!\n  $hasTopics: Boolean!\n  $hasSections: Boolean!\n  $first: Int!\n  $applicationId: String!\n) {\n  authors(filter: {entityIds: $authorIds}, first: $first) @include(if: $hasAuthors) {\n    edges {\n      node {\n        entityId\n        name\n        entityUuid\n        __typename\n        id\n      }\n    }\n  }\n  topics(filter: {entityIds: $topicIds}, first: $first, applicationId: $applicationId) @include(if: $hasTopics) {\n    edges {\n      node {\n        entityId\n        name\n        entityUuid\n        __typename\n        id\n      }\n    }\n  }\n  sections(filter: {entityIds: $sectionIds}, first: $first) @include(if: $hasSections) {\n    edges {\n      node {\n        entityId\n        name\n        entityUuid\n        __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "519c982661ac0b7ba1745108087704c6";

export default node;
